import React from 'react';
import { useNavigate } from 'react-router-dom';

const ForTenants = () => {
  const navigate = useNavigate();

  const tenantServices = [
    {
      id: 1,
      title: 'Hassle-Free Move-Ins',
      description: 'Move into a fully furnished home without any hassle. We handle all the setup, so you can start living comfortably from day one.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      ),
      color: 'from-blue-500 to-blue-600',
      path: '/services/hassle-free-move-ins'
    },
    {
      id: 2,
      title: 'Flatmate Matching',
      description: 'Find the perfect flatmate through our comprehensive matching service. We ensure compatibility and smooth co-living experiences.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      color: 'from-purple-500 to-purple-600',
      path: '/services/flatmate-matching'
    },
    {
      id: 3,
      title: 'Maintenance Resolution',
      description: 'Quick and efficient maintenance support. Any issues in your home are resolved promptly by our dedicated team.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
        </svg>
      ),
      color: 'from-green-500 to-green-600',
      path: '/services/maintenance-resolution'
    },
    {
      id: 4,
      title: 'Amenities Package',
      description: 'Enjoy premium amenities and facilities in your furnished home. Everything you need for comfortable living is included.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ),
      color: 'from-orange-500 to-orange-600',
      path: '/services/amenities-package'
    },
    {
      id: 5,
      title: 'Flexible Leasing Options',
      description: 'Choose from flexible lease terms that suit your needs. Short-term or long-term, we have options for everyone.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      ),
      color: 'from-teal-500 to-teal-600',
      path: '/services/flexible-leasing-options'
    },
    {
      id: 6,
      title: 'Vetted Properties',
      description: 'All our properties are carefully vetted for quality, safety, and comfort. Move in with confidence knowing you\'re in a great home.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
      color: 'from-pink-500 to-pink-600',
      path: '/services/vetted-properties'
    },
    {
      id: 7,
      title: 'Neighborhood Guidance',
      description: 'Get expert guidance about your neighborhood, local amenities, transportation, and everything you need to know about the area.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      color: 'from-indigo-500 to-indigo-600',
      path: '/services/neighborhood-guidance'
    },
    {
      id: 8,
      title: 'Paperwork Assistance',
      description: 'We help you with all the necessary paperwork and documentation, making your move-in process smooth and stress-free.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      ),
      color: 'from-red-500 to-red-600',
      path: '/services/paperwork-assistance'
    },
    {
      id: 9,
      title: '24/7 Support',
      description: 'Round-the-clock support whenever you need it. Our team is always available to help with any questions or concerns.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      color: 'from-cyan-500 to-cyan-600',
      path: '/services/24-7-support'
    },
    {
      id: 10,
      title: 'Community Events',
      description: 'Join community events and connect with other tenants. Build relationships and enjoy a sense of community in your new home.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      color: 'from-yellow-500 to-yellow-600',
      path: '/services/community-events'
    }
  ];

  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-2 bg-furniflex-teal/10 text-furniflex-teal rounded-full text-sm font-semibold uppercase tracking-wide mb-4">
            Tenant Services
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Everything You Need for
            <span className="block text-furniflex-teal">Comfortable Living</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Fully furnished homes with complete support and services designed to make your living experience seamless and enjoyable.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tenantServices.map((service, index) => (
            <div
              key={service.id}
              className="group relative bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-furniflex-teal/20"
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300`}></div>
              
              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  {service.icon}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-furniflex-teal transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>

                {/* Learn More Link */}
                <button 
                  onClick={() => navigate(service.path)}
                  className="inline-flex items-center gap-2 text-furniflex-teal font-semibold text-sm group-hover:gap-3 transition-all bg-transparent border-none cursor-pointer p-0"
                >
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </button>
              </div>

              {/* Decorative Number */}
              <div className="absolute top-4 right-4 text-6xl font-extrabold text-gray-100 group-hover:text-furniflex-teal/20 transition-colors">
                {String(index + 1).padStart(2, '0')}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Find Your Perfect Home?
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Join hundreds of satisfied tenants who have found their ideal furnished homes with FURNIFLEX.
          </p>
          <button 
            onClick={() => navigate('/contact')}
            className="px-8 py-4 bg-furniflex-teal text-white rounded-lg font-semibold text-lg hover:bg-teal-600 transition-colors shadow-lg"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default ForTenants;

